import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-campaign-contact-form',
    templateUrl: './campaign-contact-form.component.html',
    standalone: false
})
export class CampaignContactFormComponent {
  form: UntypedFormGroup;
  showFormError: boolean = false;

  campaignId: number;
  issuerName: string;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly modal: NgbActiveModal,
  ) {}

  close() {
    this.modal.dismiss();
  }

  submit() {}
}
